import { Injectable } from "@angular/core";
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { UserService } from "./shared-components/user/user.service";
import { Router } from "@angular/router";
import { AuthService } from "./shared-modules/login/auth.service";
import { LoginService } from "./shared-modules/login/login.service";
@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private auth: UserService,
        private authService: AuthService,
        private loginService: LoginService,
        private myRoute: Router
    ) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (this.loginService.LoginSettings.UseTID && this.loginService.hasSignedIntoTylerId) {
            const isLoggedIn = this.authService.isLoggedInObs();
            isLoggedIn.subscribe((loggedin) => {
                if (!loggedin) {
                    this.myRoute.navigate([""]);
                }
            });
            const accessToken = sessionStorage.getItem("accessToken");
            if (
                accessToken != null &&
                (this.auth.userId !== 0 ||
                    (this.auth.userType == 3 && this.auth.studentId != 0)) &&
                this.auth.isLoggedIn
            ) {
                return isLoggedIn;
            } else {
                this.myRoute.navigate([""]);
                return false;
            }            
        } else {
            const accessToken = sessionStorage.getItem("accessToken");
            if (
                accessToken != null &&
                (this.auth.userId !== 0 ||
                    (this.auth.userType == 3 && this.auth.studentId != 0)) &&
                this.auth.isLoggedIn
            ) {
                return true;
            } else {
                this.myRoute.navigate([""]);
                return false;
            }
        }
    }
}
